(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["interactive-parts-diagram"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('interactive-parts-diagram')) {
    class InteractivePartsDiagram extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('[data-parts-diagram-track]');
        this.slides = Array.from(this.querySelectorAll('[data-parts-diagram-slide]'));
        this.controls = this.querySelector('[data-parts-diagram-controls]');
        this.pagination = this.querySelector('[data-parts-diagram-pagination]');
        this.counter = this.querySelector('[data-parts-diagram-counter]');
        this.card = this.querySelector('[data-parts-diagram-card]');
        this.cardContent = this.querySelector('[data-parts-diagram-card-content]');
        this.backdrop = this.querySelector('[data-parts-diagram-backdrop]');
        this.live = this.querySelector('[data-parts-diagram-live]');
        this.currentIndex = 0;
        this.activeHotspot = null;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!this.track || !this.slides.length) return;

        this.handleClick = this.onClick.bind(this);
        this.handleKeydown = this.onKeydown.bind(this);
        this.handleDocumentClick = this.onDocumentClick.bind(this);
        this.handleResize = this.onResize.bind(this);
        this.handleBlockSelect = this.onBlockSelect.bind(this);

        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        window.addEventListener('resize', this.handleResize);

        this.buildPagination();
        this.observeSlides();
        this.updateUi(0, false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        window.removeEventListener('resize', this.handleResize);
        if (this.slideObserver) this.slideObserver.disconnect();
      }

      buildPagination() {
        if (!this.pagination) return;
        const labelTemplate = this.dataset.goToLabel || 'Go to diagram [[index]]';
        this.pagination.innerHTML = '';
        this.slides.forEach((slide, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'parts-diagram__dot';
          button.dataset.partsDiagramIndex = index;
          button.setAttribute('aria-label', labelTemplate.replace('[[index]]', index + 1));
          button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
          this.pagination.appendChild(button);
        });
        if (this.slides.length <= 1 && this.controls) this.controls.hidden = true;
      }

      observeSlides() {
        this.slideObserver = new IntersectionObserver((entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (!visible || visible.intersectionRatio < 0.55) return;
          const index = this.slides.indexOf(visible.target);
          if (index !== -1 && index !== this.currentIndex) this.updateUi(index, true);
        }, { root: this.track, threshold: [0.55, 0.75, 0.95] });
        this.slides.forEach((slide) => this.slideObserver.observe(slide));
      }

      onClick(event) {
        const hotspot = event.target.closest('[data-parts-diagram-hotspot]');
        if (hotspot && this.contains(hotspot)) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.openProduct(hotspot);
          return;
        }

        const indexButton = event.target.closest('[data-parts-diagram-index]');
        if (indexButton) {
          this.goToSlide(Number(indexButton.dataset.partsDiagramIndex));
          return;
        }

        if (event.target.closest('[data-parts-diagram-previous]')) {
          this.goToSlide(this.currentIndex - 1);
          return;
        }

        if (event.target.closest('[data-parts-diagram-next]')) {
          this.goToSlide(this.currentIndex + 1);
          return;
        }

        if (event.target.closest('[data-parts-diagram-close]') || event.target.closest('[data-parts-diagram-backdrop]')) {
          this.closeProduct(true);
        }
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.activeHotspot) {
          event.preventDefault();
          this.closeProduct(true);
          return;
        }

        if (event.target.closest('[data-parts-diagram-card]')) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goToSlide(this.currentIndex + (rtl ? -1 : 1));
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goToSlide(this.currentIndex + (rtl ? 1 : -1));
        }
      }

      onDocumentClick(event) {
        if (!this.activeHotspot) return;
        if (this.card.contains(event.target) || event.target.closest('[data-parts-diagram-hotspot]')) return;
        this.closeProduct(false);
      }

      onResize() {
        if (this.activeHotspot) this.positionCard(this.activeHotspot);
      }

      onBlockSelect(event) {
        const block = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
        if (!block) return;
        const slide = block.matches('[data-parts-diagram-slide]') ? block : block.closest('[data-parts-diagram-slide]');
        const index = this.slides.indexOf(slide);
        if (index !== -1) this.goToSlide(index, event.detail.load ? 'auto' : 'smooth');
        const hotspot = block.querySelector('[data-parts-diagram-hotspot]') || (block.matches('[data-parts-diagram-hotspot]') ? block : null);
        if (hotspot) window.setTimeout(() => this.openProduct(hotspot), 250);
      }

      goToSlide(index, behavior) {
        if (!this.slides.length) return;
        const normalized = (index + this.slides.length) % this.slides.length;
        this.slides[normalized].scrollIntoView({
          behavior: behavior || (this.reduceMotion ? 'auto' : 'smooth'),
          block: 'nearest',
          inline: 'start'
        });
        this.updateUi(normalized, true);
      }

      updateUi(index, announce) {
        if (index !== this.currentIndex) this.closeProduct(false);
        this.currentIndex = index;
        this.querySelectorAll('[data-parts-diagram-index]').forEach((button, buttonIndex) => {
          button.setAttribute('aria-current', buttonIndex === index ? 'true' : 'false');
        });
        if (this.counter) this.counter.textContent = `${index + 1} / ${this.slides.length}`;
        if (announce && this.live) {
          const template = this.dataset.statusLabel || 'Diagram [[current]] of [[total]]';
          this.live.textContent = template.replace('[[current]]', index + 1).replace('[[total]]', this.slides.length);
        }
      }

      openProduct(hotspot) {
        const template = hotspot.closest('[data-parts-diagram-hotspot-wrap]').querySelector('template');
        if (!template || !this.card || !this.cardContent) return;
        if (this.activeHotspot && this.activeHotspot !== hotspot) this.activeHotspot.setAttribute('aria-expanded', 'false');
        this.activeHotspot = hotspot;
        hotspot.setAttribute('aria-expanded', 'true');
        this.cardContent.innerHTML = template.innerHTML;
        this.card.hidden = false;
        if (this.backdrop) this.backdrop.hidden = false;
        this.classList.add('is-card-open');
        this.positionCard(hotspot);
        requestAnimationFrame(() => {
          const close = this.card.querySelector('[data-parts-diagram-close]');
          if (close) close.focus({ preventScroll: true });
        });
      }

      positionCard(hotspot) {
        if (!this.card || window.matchMedia('(max-width: 740px)').matches) {
          if (this.card) {
            this.card.style.left = '';
            this.card.style.top = '';
          }
          return;
        }
        requestAnimationFrame(() => {
          const marker = hotspot.getBoundingClientRect();
          const card = this.card.getBoundingClientRect();
          const gap = 14;
          const edge = 12;
          let left = marker.right + gap;
          if (left + card.width > window.innerWidth - edge) left = marker.left - card.width - gap;
          left = Math.max(edge, Math.min(left, window.innerWidth - card.width - edge));
          let top = marker.top + marker.height / 2 - card.height / 2;
          top = Math.max(edge, Math.min(top, window.innerHeight - card.height - edge));
          this.card.style.left = `${left}px`;
          this.card.style.top = `${top}px`;
        });
      }

      closeProduct(restoreFocus) {
        if (!this.activeHotspot) return;
        const hotspot = this.activeHotspot;
        hotspot.setAttribute('aria-expanded', 'false');
        this.activeHotspot = null;
        if (this.card) {
          this.card.hidden = true;
          this.card.style.left = '';
          this.card.style.top = '';
        }
        if (this.backdrop) this.backdrop.hidden = true;
        this.classList.remove('is-card-open');
        if (restoreFocus) hotspot.focus({ preventScroll: true });
      }
    }

    customElements.define('interactive-parts-diagram', InteractivePartsDiagram);
  }

  } catch(e) { console.error(e); }
})();
})();
